import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import { MainListItems } from '../listItems';

const drawerWidth = 240;
const useStyles = makeStyles(theme => ({
	toolbarIcon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		padding: '0 8px',
		...theme.mixins.toolbar
	},
	drawerPaper: {
		position: 'relative',
		height: '100%',
		overflowX: 'hidden',
		overflowY: 'auto',
		whiteSpace: 'nowrap',
		width: drawerWidth,
		'& .MuiListItemText-root': {
			minWidth: 0
		},
		'& .MuiListItemText-primary': {
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		},
		transition: theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		})
	},
	drawerPaperClose: {
		overflowX: 'hidden',
		transition: theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		}),
		width: theme.spacing(7),
		[theme.breakpoints.up('sm')]: {
			width: theme.spacing(9)
		}
	},
	paper: {
		padding: theme.spacing(2),
		display: 'flex',
		overflow: 'auto',
		flexDirection: 'column'
	}
}));

export default function NavigationSideMenu({ onToolbarIconClick, open }) {
	const classes = useStyles();

	return (
		<Drawer
			variant="permanent"
			classes={{
				paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose)
			}}
			open={open}
		>
			<div className={classes.toolbarIcon}>
				<IconButton onClick={onToolbarIconClick}>
					<ChevronLeftIcon />
				</IconButton>
			</div>
			<Divider />
			<MainListItems />
			<Divider />
		</Drawer>
	);
}
